import { Link } from "react-router-dom";
import styled, { createGlobalStyle } from "styled-components";
import makerstreetLogo from "../../assets/img/makerstreet_logo.png";

export const GlobalStyles = createGlobalStyle`
  *,
  *:before,
  *:after {
    margin: 0;
    padding: 0;
  }
  body {
    width: 100%;
    height: 100%;
    font-family:  ${({ theme }) => theme.fonts.body};
    font-size: ${({ theme }) => theme.fontSizes.body};
    font-weight: ${({ theme }) => theme.fontWeights.light};
    background: ${({ theme }) => theme.color.body};
    color: ${({ theme }) => theme.color.text};
    transition: all 0.50s linear;
  }

  button, input, textarea, p, span, a, h4 {
    font-family: ${({ theme }) => theme.fonts.body};
    font-weight: ${({ theme }) => theme.fontWeights.regular};
  }

  div, ul {
    box-sizing:border-box;
  }

  .recharts-tooltip-cursor {
    display: none;
  }
`;

type ContainerT = {
  height?: string;
  maxHeight?: string;
  minHeight?: string;
  noPadding?: boolean;
  padding?: string;
};

const Container = styled.div<ContainerT>`
  max-width: 1180px;
  height: ${({ height }) => height ?? "100vh"};
  min-height: ${({ minHeight }) => minHeight ?? "100vh"};
  max-height: ${({ maxHeight }) => maxHeight && maxHeight};
  margin: 0 auto;
  padding: ${({ noPadding, padding }) => (noPadding ? 0 : padding || "16px")};
  @media (min-width: 768px) {
    box-shadow: 0px 3px 8px 3px rgba(219, 219, 219, 1);
  }
  position: relative;

  && > div:last-child {
    border-bottom: 0;
  }
`;

type FlexT = {
  height?: string;
  width?: string;
  justifyContent?: string;
  alignItems?: string;
  margin?: string;
  padding?: string;
  flex?: string;
};

const Flex = styled.div<FlexT>`
  display: flex;
  flex: ${({ flex }) => flex};
  justify-content: ${(props) => props.justifyContent};
  align-items: ${({ alignItems }) => alignItems || "center"};
  margin: ${(props) => props.margin};
  padding: ${(props) => props.padding};
  height: ${({ height }) => height};
  width: ${({ width }) => width};
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: -ms-autohiding-scrollbar;
`;

const FlexColumn = styled.div<FlexT>`
  width: 100%;
  position: relative;
  flex: ${({ flex }) => flex};
  height: ${({ height }) => height || "100%"};
  display: flex;
  flex-direction: column;
  justify-content: ${(props) => props.justifyContent};
  align-items: ${(props) => props.alignItems};
  margin: ${(props) => props.margin};
  padding: ${(props) => props.padding};
`;

const HeaderBar = styled.div`
  width: 100%;
  background-color: transparent;
  display: flex;
  align-items: center;
  margin: 24px 0 30px 0;
`;

const HyperLink = styled(Link)`
  color: ${({ theme }) => theme.color.darkPurple};
  font-weight: bold;
  font-size: 14px;
  text-decoration: none;
  font-family: "Urbane";
`;

const Form = styled.form`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const InputsContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 350px;
`;

const MakerstreetLogo = styled.div`
  position: absolute;
  width: 40px;
  height: 40px;
  background-image: url(${makerstreetLogo});
  background-position: center;
  background-repeat: no-repeat;
`;

const StickyFooter = styled.div`
  position: sticky;
  bottom: 0;
  z-index: 10;
  border-radius: 8px 8px 0 0;
  background-color: ${({ theme }) => theme.color.body};
  color: ${({ theme }) => theme.color.text};
  box-shadow: ${({ theme }) => theme.color.shadow};
  padding-top: ${({ theme }) => theme.spaces.large};
  padding-right: ${({ theme }) => theme.spaces.regular};
  padding-bottom: ${({ theme }) => theme.spaces.large};
  padding-left: ${({ theme }) => theme.spaces.regular};
  margin-right: -${({ theme }) => theme.spaces.regular};
  margin-left: -${({ theme }) => theme.spaces.regular};
`;

export {
  Container,
  Flex,
  FlexColumn,
  HeaderBar,
  HyperLink,
  Form,
  InputsContainer,
  MakerstreetLogo,
  StickyFooter,
};
